var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { "background-color": "var(--primary-normal)" },
      attrs: {
        row: "",
        "fill-height": "",
        "align-center": "",
        "justify-center": "",
        wrap: ""
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { shrink: "" } },
        [
          _c("div", { staticClass: "warning-message" }, [
            _vm._v("\n      404\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "warning-message",
              staticStyle: { "font-size": "30px" }
            },
            [
              _vm._v(
                "\n      Sorry, the page you're looking for doesn't exist.\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticStyle: { "text-transform": "none" },
              attrs: { text: "", color: "accent" },
              on: {
                click: function($event) {
                  return _vm.$router.back()
                }
              }
            },
            [_vm._v("\n      Previous Page\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c78d7b50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c78d7b50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageNotFound.vue
// module id = null
// module chunks = 